<template lang="pug">
  v-container.fill-height(style="align-items: center")
    v-row
      v-col
        v-card(style="width: 100%")
          v-row
            v-col
              v-list
                v-list-item
                  v-list-item-avatar
                    v-img(
                      :src="$get(ad, `user.image.src`)"
                      @click="goToGiver")
                  v-list-item-content
                    v-list-item-title {{ $get(ad, `user.name`) }}   
                    v-list-item-subtitle  vous permet de faire un don gratuit  
                  v-list-item-action
                    v-btn(icon)
                      v-icon {{ mdiDotsVertical }}
          v-row.px-8
            v-col {{ $get(ad, `endingMessage`) }}
          v-row.justify-center.text-center
            v-col
              v-rating(
                v-model="rating"
                background-color="grey"
                color="yellow")
          v-row.justify-center.text-center(
            v-if="$get(ad, `endingUrl`)")
            v-col
              v-btn(
                @click="$createOnClick({ goToExternalUrl })"
                color="primary") En savoir plus
                
    v-row
      v-col.text-center
        v-btn(
          @click="$createOnClick({ finish })"
          color="primary") Terminer
</template>

<script>
import { ref, onBeforeUnmount } from '@vue/composition-api'

import { page, injectRouteState } from '@iez/core'
import { mdiDotsVertical } from '@mdi/js'
import IllustrationState from '@iez/components/illustration-state/'
import illustration from '@iez/illustrations/SocialInfluencer'
import user from '@iez/lib/user/'
import data from '@iez/lib/data/'
import router from '@iez/core/router'
import waitFor from '@iez/lib/wait-for/'
import $goToExternalUrl from '@iez/lib/go-to-external-url/'

const route = {
  name: `AdWatchSuccess`,
  path: `/ad-watch-success`
}

export default {
  ...route,

  components: {
    IllustrationState
  },

  setup () {
    const routeStateAdWatch = injectRouteState({
      name: `AdWatch`
    })

    const rating = ref(null)
    const viewAdId = ref(null)

    const goToExternalUrl = () => {
      data.update({
        root: `ads`,
        id: ad.value.id,
        _set: {
          countLink: ad.value.countLink + 1,
          //countVisit: ad.value.countVisit + 1
        },
        fields: [
          `id`,
          `countLink`
        ]
      })
      $goToExternalUrl({ url: ad.value.endingUrl })
    }

    //const countLink = ref(null)

    const ad = data.get({
      root: `ads`,
      one: true,
      request: {
        where: {
          id: {
            _eq: routeStateAdWatch.adId
          }
        }
      },
      fields: [
        `id`,
        `name`,
        `viewsCountRemaining`,
        `endingUrl`,
        `countLink`,
        `countVisit`,
        `endingMessage`, {
          user: [
            `id`,
            'name', {
            image: [
              `id`,
              `src`,
              `srcLazy`
            ]
          }],
        }
      ]
    })

    waitFor({
      dependencies: () => ad.value?.id,
    }).then(id => {
      data.update({
        root: `ads`,
        id,
        _set: {
          viewsCountRemaining: ad.value.viewsCountRemaining - 1
        },
        fields: [
          `id`,
          `viewsCountRemaining`
        ]
      })
    })

    data.set({
      root: `viewsAds`,
      items: [{
        viewerId: user.id,
        adId: routeStateAdWatch.adId,
        supportedAssociationId: routeStateAdWatch.supportedAssociationId
      }],
      fields: [
        `id`
      ],
      one: true
    }).then(viewAd => {
      viewAdId.value = viewAd.id
    })

    page.topBar.set({
      title: `Évaluation`
    })

    /* const getLabel = ({ rating }) =>
      rating < 1.5
        ? `Mauvais`
        : rating < 2.5
          ? `Acceptable`
          : rating < 3.5
            ? `Bien`
            : rating < 4.5
              ? `Très bien`
                : `Excellent` */

    /* page.bottomAction.set(
      () => rating.value !== null
        ? {
          side: {
            title: getLabel({ rating: rating.value }),
            subtitle: `${rating.value} / 5`
          },
          action: {
            label: `Noter`,
            onClick: async () => {
              await data.update({
                root: `viewsAds`,
                id: viewAdId.value,
                _set: {
                  rating: rating.value * 2
                },
                fields: [
                  `id`,
                  `rating`
                ]
              })
              page.bottomSnackbar.set({
                content: `Note envoyée ! Merci.`
              })
              router.back()
            }
          }
        } : null
    ) */

    const { unset } = page.bottomSnackbar.set({
      content: `Yako vous remercie pour votre don à cette association.`
    })

    onBeforeUnmount(() => {
      unset()
    })

    const finish = async () => {
      await data.update({
        root: `viewsAds`,
        id: viewAdId.value,
        _set: {
          rating: rating.value === null  //peut-etre on ne peut pas mettre de 0 et donc tjr faux
            ? null
            : rating.value * 2,
        },
        fields: [
          `id`,
          `rating`,
        ]
      })
      page.bottomSnackbar.set({
        content: `Note envoyée ! Merci.`
      })
      router.back()
    }

    const goToGiver = () => {
      const { id } = ad.value.user
      const isMe = id === user.id
      data.update({
        root: `ads`,
        id: ad.value.id,
        _set: {
          countVisit: ad.value.countVisit + 1
        },
        fields: [
          `id`,
          `countVisit`
        ]
      })
      router.push({
        name: `Profile`,
        ...!isMe
          ? {
            params: {
              id
            },
            query: {
              heroIdProfileAvatar: `heroId`
            }
          } : null
      })
    }

    return {
      rating,
      goToExternalUrl,
      illustration,
      title: `Quelle note pour l'annonce ?`,
      mdiDotsVertical,
      finish,
      goToGiver,
      ad
    }
  }
}
</script>
